module.exports = __webpack_public_path__ + "static/img/sdwyj_img2.009a696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sdwyj_img2.png
// module id = iWm6
// module chunks = 1